
import React from "react";
import { DocumentRequirement } from "../hooks/useDocumentRequirements";

interface DocumentRequirementsListProps {
  documentsNeeded: DocumentRequirement[];
}

export const DocumentRequirementsList: React.FC<DocumentRequirementsListProps> = ({ 
  documentsNeeded 
}) => {
  if (documentsNeeded.length === 0) return null;

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium mb-3">Required Documents</h3>
      <div className="space-y-2">
        {documentsNeeded.map((doc, i) => (
          <div
            key={i}
            className={`flex items-start p-3 border rounded-md ${
              doc.fulfilled
                ? "bg-green-50 border-green-200"
                : "bg-amber-50 border-amber-200"
            }`}
          >
            <div
              className={`mt-0.5 p-1 rounded-full ${
                doc.fulfilled ? "bg-green-100" : "bg-amber-100"
              }`}
            >
              {doc.fulfilled ? (
                <svg
                  className="h-4 w-4 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              ) : (
                <svg
                  className="h-4 w-4 text-amber-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              )}
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium">{doc.description}</p>
              <p className="text-xs text-gray-500 mt-0.5">
                {doc.fulfilled ? "Provided" : "Required"}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
